import Head from "next/head";
import { Thing } from "schema-dts";

interface StructuredDataProps {
  schemas: Thing[];
}

// Escape characters that could let a string value break out of the <script>.
const serializeSchema = (schema: Thing) =>
  JSON.stringify(schema)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");

const StructuredData = ({ schemas }: StructuredDataProps) => {
  return (
    <Head>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: serializeSchema(schema) }}
        />
      ))}
    </Head>
  );
};

export default StructuredData;
